
import { Component, Vue, Prop } from "vue-property-decorator";
// import { stringCallback } from "@/common/common-interface";
@Component
export default class ShowImgUrl extends Vue {
  @Prop({ default: "" }) private imgUrl!: string;
  @Prop({ default: 0 }) private index!: number;
  @Prop({ default: false }) private remove!: boolean;
  public getUrl(url: string): string {
    if (url.indexOf("http://") == -1 || url.indexOf("https://") == -1) {
      return this.$config.fileImg + url;
    } else {
      return url;
    }
  }

  public removeImg() {
    this.$emit("remove", this.index);
  }
}
